import { render, staticRenderFns } from "./ChatScreen.vue?vue&type=template&id=4e386043&scoped=true&"
import script from "./ChatScreen.vue?vue&type=script&lang=js&"
export * from "./ChatScreen.vue?vue&type=script&lang=js&"
import style0 from "./ChatScreen.vue?vue&type=style&index=0&id=4e386043&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e386043",
  null
  
)

export default component.exports